module.exports = __webpack_public_path__ + "img/menu-button.3509bd65.svg";